import React from 'react';
import { connect } from 'react-redux';
import { showModalMessage } from '../store/modalsSlice';
import EditingDataHistoryDialog from '../components/editingDataHistoryDialog';
import TrialRejectedDeviceHistoryTable from '../components/trialRejectedDeviceHistoryTable';
import * as objectHistory from '../store/objectHistorySlice';
import { objectHistoryNames, objectHistorySelectors } from '../store/objectHistorySlice';
import { trialRejectedDevicesSelectors } from '../store/trialRejectedDevicesSlice';
import TrialRejectedDeviceHistoryTableHeader from '../components/trialRejectedDeviceHistoryTableHeader';

class TrialRejectedDeviceHistoryDialog extends EditingDataHistoryDialog {
  get dataId() {
    return this.props.id;
  }

  get Title() {
    return 'Trial rejected device history';
  }

  renderTable(tableProps) {
    return <TrialRejectedDeviceHistoryTable {...tableProps}/>
  }

  renderBeforeContent() {
    const objectData = this.props.selectedTrialRejectedDevices(this.props.id);
    const editedFields = this.props.getEditedFields();
    return <TrialRejectedDeviceHistoryTableHeader editedFields={editedFields} objectData={objectData}/>;
  }

  getLoaderMessage() {
    return 'Trial rejected device history loading...';
  }
}

const mapStateToProps = (state) => ({
  objectState: objectHistorySelectors.trialRejectedDevices(state),
  getEditedFields: () => objectHistorySelectors.trialRejectedDevicesEditedFields(state),
  selectedTrialRejectedDevices: (id) => trialRejectedDevicesSelectors.selectById(state, id),
});

const actionCreators = {
  fetchHistory: (trialRejectedDeviceId) => objectHistory.fetchHistory(trialRejectedDeviceId, objectHistoryNames.trialRejectedDevices),
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(TrialRejectedDeviceHistoryDialog);



// WEBPACK FOOTER //
// ./src/containers/trialRejectedDeviceHistoryDialog.js